import { Box, VStack } from '@chakra-ui/react';
import { DEMO_EMAIL } from '../constants';
import { CtaButtons } from './CtaButtons';

export function PlatformAccessCta() {
  return (
    <Box
      w="full"
      maxW="780px"
      py={{ base: 4, md: 6 }}
      px={{ base: 4, md: 10 }}
      borderRadius={{ base: 'lg', md: 'xl' }}
      border="1px solid"
      borderColor="whiteAlpha.100"
      bg="gray.900"
    >
      <VStack spacing={{ base: 3, md: 4 }} textAlign="center">
        <Box
          as="h3"
          color="white"
          fontSize={{ base: 'xl', md: '2xl' }}
          fontWeight="bold"
          lineHeight="1.25"
        >
          Give your defenders adversary-level capabilities
        </Box>
        <CtaButtons primary={{ href: DEMO_EMAIL, label: 'Request Access' }} />
      </VStack>
    </Box>
  );
}
